import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

import * as fromModels from '../models';
import * as fromUi from './ui.reducer';
import * as fromRouter from './router.reducer';

export * from './router.reducer';

export interface IRootState {
  uiState: fromModels.IUiModel;
  router: RouterReducerState<fromRouter.RouterStateUrl>;
}

export const reducers: ActionReducerMap<IRootState> = {
  uiState: fromUi.reducer,
  router: routerReducer
};

export const getUiState = createFeatureSelector<fromModels.IUiModel>('uiState');



// WEBPACK FOOTER //
// ./src/app/shared/store/reducers/index.ts